/* Adventure mega menu: hover/click panels on desktop, accordions in the mobile drawer. */

if (!customElements.get('adv-mega-nav')) {
  class AdvMegaNav extends HTMLElement {
    connectedCallback() {
      this.scrim = this.nextElementSibling?.classList.contains('adv-nav__scrim') ? this.nextElementSibling : null;
      this.current = null;
      this.timer = null;
      this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

      this.querySelectorAll('.adv-nav__item').forEach((item) => {
        const trigger = item.querySelector('.adv-nav__trigger');
        item.addEventListener('mouseenter', () => {
          if (!this.canHover.matches) return;
          clearTimeout(this.timer);
          this.timer = setTimeout(
            () => (trigger ? this.open(trigger) : this.close()),
            this.current ? 0 : 120
          );
        });
        if (trigger) {
          trigger.addEventListener('click', () => {
            clearTimeout(this.timer);
            trigger === this.current ? this.close() : this.open(trigger);
          });
        }
      });

      this.addEventListener('mouseleave', () => {
        if (!this.canHover.matches) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.close(), 250);
      });

      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
      });

      this.scrim?.addEventListener('click', () => this.close());

      this.onKeyUp = (event) => {
        if (event.key !== 'Escape' || !this.current) return;
        const trigger = this.current;
        this.close();
        trigger.focus();
      };
      document.addEventListener('keyup', this.onKeyUp);
    }

    disconnectedCallback() {
      document.removeEventListener('keyup', this.onKeyUp);
      clearTimeout(this.timer);
    }

    open(trigger) {
      if (this.current === trigger) return;
      this.close(true);
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      if (this.scrim) this.scrim.hidden = false;
      this.current = trigger;
    }

    close(keepScrim = false) {
      if (this.current) {
        this.current.setAttribute('aria-expanded', 'false');
        const panel = document.getElementById(this.current.getAttribute('aria-controls'));
        if (panel) panel.hidden = true;
      }
      this.current = null;
      if (this.scrim && !keepScrim) this.scrim.hidden = true;
    }
  }

  customElements.define('adv-mega-nav', AdvMegaNav);

  /* Shorter search placeholder on phones */
  const advSearchInput = document.getElementById('AdvSearch');
  if (advSearchInput && advSearchInput.dataset.placeholderShort) {
    const longPlaceholder = advSearchInput.placeholder;
    const phone = window.matchMedia('(max-width: 749px)');
    const setPlaceholder = () => {
      advSearchInput.placeholder = phone.matches ? advSearchInput.dataset.placeholderShort : longPlaceholder;
    };
    setPlaceholder();
    phone.addEventListener('change', setPlaceholder);
  }

  /* Mobile drawer accordions */
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.adv-acc__toggle');
    if (!toggle) return;
    const list = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!list) return;
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    list.hidden = isOpen;
  });
}
